// Badge on the "ERP journals" tab: how far the Accountant step is from approval.
// The tab name stays fixed; the badge carries what changes.
//   { text, tone } or null (nothing to show — e.g. not the person working the step).
const HSBC_CODES = ["hsbc_package_not_ready", "hsbc_package_stale"];

export const journalTabBadge = (pr, { working } = {}) => {
  if (!working) return null;
  const { required = 0, created = 0 } = pr?.journal_progress || {};
  if (required > 0 && created < required) return { text: `${created}/${required} created`, tone: "warn" };
  const blockers = Array.isArray(pr?.blocked_by) ? pr.blocked_by : [];
  if (blockers.some((b) => HSBC_CODES.includes(b.code))) return { text: "HSBC file needed", tone: "warn" };
  if (blockers.length > 0) return { text: `${blockers.length} to fix`, tone: "warn" };
  return required > 0 ? { text: "Ready to approve", tone: "ok" } : null;
};
